import axios from '@/components/axios';

const baseApi = process.env.VUE_APP_APIENDPOINT || 'http://localhost:8000/api';

export const moduleService = {
  // Create module with routes
  async createModule(moduleData) {
    try {
      const response = await axios.post(`${baseApi}/modules`, moduleData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Update module with routes
  async updateModule(id, moduleData) {
    try {
      const response = await axios.put(`${baseApi}/modules/${id}`, moduleData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Get module by ID
  async getModuleById(id) {
    try {
      const response = await axios.get(`${baseApi}/getmodulesById/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Get all modules
  async getAllModules(params = {}) {
    try {
      const response = await axios.get(`${baseApi}/modules`, { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  handleError(error) {
    if (error.response) {
      // Server responded with error
      return {
        message: error.response.data.message || 'An error occurred',
        errors: error.response.data.errors || {},
        status: error.response.status,
      };
    } else if (error.request) {
      // Request made but no response
      return {
        message: 'No response from server',
        errors: {},
      };
    } else {
      // Error setting up request
      return {
        message: error.message || 'An error occurred',
        errors: {},
      };
    }
  },
};

